<ion-img
  *ngIf="otherParameters"
  [src]="otherParameters.Imagen"
  style="height: 100%; background: rgb(122, 130, 142)"
></ion-img>

<ion-button
  mode="md"
  fill="clear"
  (click)="onDismiss()"
  color="white"
  [ngStyle]="otherParameters.Posicion_Boton"
>
  <ion-label>{{ otherParameters.Texto_Boton }}</ion-label>
</ion-button>
